import React from 'react';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    breadcrumbButton: {
        textTransform: 'none',
        minWidth: 0,
    },
});

export default function BreadrcrumbButton(props) {
    const { isActivePage, fileSystemNodePath, fileSystemNodeType, directoryName, setSelectedFileSystemNodePath } = props;
    const classes = useStyles();

    const handleClick = () => {
        if (isActivePage) {
            return;
        }
        setSelectedFileSystemNodePath(fileSystemNodePath, fileSystemNodeType);
    }

    return (
        <Button variant="text" className={classes.breadcrumbButton} onClick={handleClick}>{directoryName}</Button>
    );
}